
import React from 'react';
import { observer } from 'mobx-react-lite';

import { ProfilePlaceholder } from '@vromo/ui/components/ProfileImage';
import { Platform } from '@vromo/models/Integration';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { isNil } from 'lodash';
import { dataTestId } from '@vromo/models';
import { css } from 'emotion';
import { useIntegrationsNav, useIntegrationsPage } from '../hooks';


type IntegrationRowProps = {
    platform: Platform;
}




export const IntegrationRow = observer<IntegrationRowProps>(({
    platform
}) => {

    const { goToWindow } = useIntegrationsNav()
    const { isLoading, fetchedIntegrations } = useIntegrationsPage()
    const instance = fetchedIntegrations.get(platform)!

    return (
        <tr
            onClick={() => !instance.status && goToWindow("details", instance.platform)}
            style={{ cursor: isLoading ? 'default' : 'pointer' }}
            data-testid={dataTestId.integration.row + instance.platform}
        >
            <td style={{ textAlign: 'center', width: 50 }}>
                <ProfilePlaceholder initials={platform[0]!} id={platform.length} />
            </td>
            <td className={css`
                width: 30%;
                :first-letter {text-transform: uppercase};
            `}>
                {instance.platform}
            </td>
            <td>
                {
                    !isNil(instance.status) ?
                        <span><FontAwesome icon="exclamation-triangle" /> {instance.status} </span> :
                        <>
                            {
                                instance.completed &&
                                <span>
                                    {
                                        instance.enabled ?
                                            <><FontAwesome icon="fa-solid fa-check" /> Enabled</> :
                                            <><FontAwesome icon="exclamation-triangle" /> Disabled</>
                                    }
                                </span>
                            }
                            {
                                !instance.completed &&
                                <span><FontAwesome icon="exclamation-triangle" /> Incomplete </span>
                            }
                        </>
                }
            </td>
        </tr >
    );
});
